import { createApp } from "vue";
import App from "./App.vue";
import "./css/tailwind.css";

import AOS from 'aos'
import 'aos/dist/aos.css'

import PerfectScrollbar from "vue3-perfect-scrollbar";
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import '@splidejs/vue-splide/css/core';

const app = createApp(App)
app.AOS = new AOS.init({ once: true });
app.use(PerfectScrollbar)
app.use(AOS)
app.mount("#app")